module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "centera"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('strong', [_vm._v("Also by Juliet Marillier")])]), _vm._v(" "), _c('p', {
    staticClass: "centeraa"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVENWATERS")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RILOGY")])]), _vm._v(" "), _c('p', {
    staticClass: "centerab"
  }, [_c('em', [_vm._v("Daughter of the Forest")])]), _vm._v(" "), _c('p', {
    staticClass: "centerab"
  }, [_c('em', [_vm._v("Son of the Shadows")])]), _vm._v(" "), _c('p', {
    staticClass: "centerab"
  }, [_c('em', [_vm._v("Child of the Prophecy")])]), _vm._v(" "), _c('p', {
    staticClass: "centeraaa"
  }, [_c('em', [_vm._v("Wolfskin")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55bc5fc1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abouttheauthor.vue
// module id = 60
// module chunks = 0